<template>
<div>
  <el-dialog title="会话管理" class="title"
             :lock-scroll="false"
             :visible.sync="visible"
             :close-on-press-escape="closeOnPressEscape"
             width="880px"
             top="6vh"
             @open="focusSearch"
             @close="$emit('close')"
             @keyup.native.f2.exact="F2Handler"
             @keydown.native.enter.exact="enterHandler"
             @keydown.native.delete.exact="deleteHandler"
             @keydown.native.ctrl.a.exact="selectAllHandler"
             @keydown.native.ctrl.x.exact="cutHandler"
             @keydown.native.ctrl.c.exact="copyHandler"
             @keydown.native.ctrl.v.exact="pasteHandler"
  >
    <div>
<!--      工具面板-->
      <sessions-tools
          ref="tools"
          @newSess="newSessHandler"
          @refresh="refresh"
          @up="upHandler"
          @down="downHandler"
          @left="leftHandler"
          @right="rightHandler"
          @enter="enterHandler"
          @searchUpdate="searchUpdateHandler"
          @details="detailsHandler"
          @delete="deleteHandler"
          @cut="cutHandler"
          @copy="copyHandler"
          @paste="pasteHandler"
          @newDir="newDirHandler"
          @keydown.native.delete.stop="skipHandler"
          @keydown.native.ctrl.a.stop="skipHandler"
          @keydown.native.ctrl.x.stop="skipHandler"
          @keydown.native.ctrl.c.stop="skipHandler"
          @keydown.native.ctrl.v.stop="skipHandler"
      />

      <div class="filepath-ctn">
        <el-checkbox class="filepath-check" v-model="checkCurAllCheckBox"></el-checkbox>
        <!-- 当前路径 -->
        <div class="filepath" ><filepath @clickPath="clickPathHandler" :fullPath="curFullPath" /></div>
      </div>

<!--      树状会话列表-->
      <div class="tree-ctn" :class="{ treeFrame: treeFrameVisible}">
        <!-- sessions tree 内更新 treeData 无法更新数据, 将其 dom v-if 绑定到 treeVisible 确保每次打开都刷新数据 -->
        <sessions-tree
            v-if="treeVisible"
            :root="sessionsRoot"
            ref="sessTree"
            @connect="connect(arguments[0], arguments[1])"
            @curPathChanged="p => {curPath = p}"
            @curDirChanged="d => {curDir = d}"
            @curIsDirChanged="isDir => {curIsDir = isDir}"
            @isEditingNode="isEditingNodeHandler"
            @refreshRequest="refresh"
            @updateFrameVisible="treeFrameHandler"
        />
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <div class="footer">
        <div><el-checkbox v-model="autoShow">打开新窗口时显示此对话框</el-checkbox></div>
        <div>
          <el-button @click="env.ui.showImportSession()" size="mini">导 入</el-button>
          <el-button @click="exportHandler" size="mini">导 出</el-button>
          <el-button @click="hide" size="mini">关 闭</el-button>
          <el-button type="primary" @click="clickConnectHandler" size="mini">打 开</el-button>
        </div>
      </div>
    </span>
  </el-dialog>

  <!-- 如果当前选中的是目录, 则将选中的目录路径传递进去, 如果当前选中的不是目录, 则将 curDir 传递进去 -->
  <new-session ref="newSess" :sessDir="curIsDir ? curFullPath : curFullDir" @closed="focusSearch" />
  <edit-session ref="editSess" @closed="focusSearch" />
</div>
</template>

<script>
import SessionsTools from "./sessionsTools";
import NewSession from "./newSession";
import EditSession from "./editSession";
import sessionsTree from "./sessionsTree";
import filepath from '../common/filepath.vue'

const path = require('path')

export default {
  name: "sessions",
  components: {sessionsTree, NewSession, EditSession, SessionsTools, filepath},
  data() {
    return {
      visible: false,
      autoShow: undefined,
      sessionsRoot: this.env.sess.basePath,
      curDir: "/",
      curPath: "/",
      curIsDir: false,
      treeVisible: true,
      closeOnPressEscape: true,
      treeFrameVisible: false,
      checkCurAllCheckBox: false,
    }
  },
  computed: {
    curFullDir: function() {
      return this.treePath2fullPath(this.curDir)
    },
    curFullPath: function() {
      return this.treePath2fullPath(this.curPath)
    },
  },
  mounted() {
    let self = this
    this.env.showSessionListAddCallback((ctrl) => {
      if (ctrl && ctrl.refresh) self.refresh()
      self.show()
    })

    // 进入 app 是自动打开会话列表面板
    self.autoShow = this.env.ui.getShowSessionsOnNewWindow()
  },
  watch: {
    visible: function() {
      this.treeVisible = this.visible
    },
    autoShow: function() {
      this.env.ui.setShowSessionsOnNewWindow(this.autoShow)
    },
    curIsDir: function() {
      console.log("curIsDir:", this.curIsDir)
      console.log("curDir:", this.curDir)
      console.log("curPath:", this.curPath)
    },
    checkCurAllCheckBox: function() {
      if (this.checkCurAllCheckBox === true) {
        this.$refs.sessTree.checkCurAllChildren()
        return
      }
      this.$refs.sessTree.uncheckCurAllChildren()
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
    },
    focusSearch() {
      // 首次打开会话列表时 this.$refs.tools 是 undefined
      let tools = this.$refs.tools
      tools ? tools.focus() : null
    },
    refresh() {
      // 通过销毁再生成 sessions tree 来模拟刷新
      this.treeVisible = false
      let self = this
      setTimeout(() => {self.treeVisible = true}, 0)
    },
    connect(treePath, file) {
      let sess = JSON.parse(window.atob(file.Data))

      this.hide()
      this.env.tabNewTab({
        path: treePath,
        sess: sess,
      })
    },
    clickConnectHandler() {
      this.$refs.sessTree ? this.$refs.sessTree.enterHandler() : console.log("clickConnectHandler: this.$refs.sessTree is undefined now")
    },
    newSessHandler() {
      this.$refs.newSess.show()
    },
    upHandler() {
      this.$refs.sessTree.selectPrev()
    },
    downHandler() {
      this.$refs.sessTree.selectNext()
    },
    leftHandler() {
      this.$refs.sessTree.collapseCurNode()
    },
    rightHandler() {
      this.$refs.sessTree.expandCurNode()
    },
    enterHandler() {
      this.$refs.sessTree ? this.$refs.sessTree.enterHandler() : console.log("enterHandler: this.$refs.sessTree is undefined now")
    },
    exportHandler() {
      this.utils.sess.exportAllSession(this)
    },
    searchUpdateHandler(search) {
      this.$refs.sessTree.search(search)
    },
    detailsHandler() {
      this.$refs.editSess.show(this.curFullPath)
    },
    deleteHandler() {
      console.log("delete session handler")
      this.$confirm('此操作将永久删除选中的会话, 是否继续?', '删除回话', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$refs.sessTree.deleteSelected()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    cutHandler() {
      this.$refs.sessTree.cutSelected()
    },
    copyHandler() {
      this.$refs.sessTree.copySelected()
    },
    pasteHandler() {
      this.$refs.sessTree.pasteSelection()
    },
    newDirHandler() {
      this.$refs.sessTree.newDir()
    },
    isEditingNodeHandler(isEditing) {
      if (!isEditing) {
        this.focusSearch()
        this.refresh()
      }
      setTimeout(() => {this.closeOnPressEscape = !isEditing}, 0)
    },
    F2Handler() {
      this.$refs.sessTree.renameSelectedNode()
    },
    clickPathHandler(clickPath) {
      console.debug("clickPathHandler: clickPath", clickPath)
      console.debug("clickPathHandler: this.fullPath2treePath(clickPath)", this.fullPath2treePath(clickPath))
      this.$refs.sessTree.selectNodeByFullPath(this.fullPath2treePath(clickPath))
    },
    treePath2fullPath(treePath) {
      return path.join(this.env.sess.basePath, treePath)
    },
    fullPath2treePath(fullPath) {
      let treePath = "/"
      let names = fullPath.split(path.sep)
      if (!names.length || names.length < 2) {
        return treePath
      }

      for(let i = 2; i < names.length; i++) {
        treePath = path.join(treePath, names[i])
      }
      return treePath
    },
    treeFrameHandler(visible) {
      this.treeFrameVisible = visible
    },
    selectAllHandler() {
      console.log("select all")
      this.$refs.sessTree.selectCurAllChildren()
    },
    skipHandler() {
      console.log("skip handler")
    }
  },
}
</script>

<style scoped>
.title {
  user-select: none;
}
.filepath-ctn {
  display: flex;
  align-items: flex-start;
}
.filepath-check {
  margin-top: 1.5px;
}
.filepath {
  width: 100%;
  justify-content: flex-start;
  align-items: baseline;
  text-align: left;
}
.tree-ctn {
  max-height: 60vh;
  overflow: auto;
  border: transparent solid 1px;
}
.footer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.treeFrame {
  border: #409EFF solid 1px;
}
</style>
